import type { AccountCampaignBulkResult } from '../../types/accountCampaign';

// Rendered inside the toast shell after a bulk action. Shows {succeeded} on
// its own or paired with a scrollable rejection list when any rows failed
// the ready-gate (or other) per-row validation (spec §6.3).

type Props = {
  result: AccountCampaignBulkResult;
  actionLabel: string;
  onDismiss: () => void;
};

export function BulkRejectionToast({ result, actionLabel, onDismiss }: Props) {
  const anyRejected = result.rejected.length > 0;
  return (
    <div
      className={`fixed bottom-6 right-6 z-40 w-[26rem] max-w-full rounded-md border bg-white p-4 shadow-xl ${
        anyRejected ? 'border-amber-300' : 'border-emerald-300'
      }`}
      role="status"
    >
      <div className="flex items-start justify-between gap-3">
        <p className="text-sm font-medium text-slate-900">
          {result.succeeded} {result.succeeded === 1 ? 'row' : 'rows'} {actionLabel}.{' '}
          {anyRejected && (
            <span className="text-amber-700">
              {result.rejected.length} rejected:
            </span>
          )}
        </p>
        <button
          type="button"
          onClick={onDismiss}
          className="text-slate-400 hover:text-slate-700 -mt-1"
          aria-label="Dismiss"
        >
          ✕
        </button>
      </div>
      {anyRejected && (
        <ul className="mt-2 max-h-64 overflow-auto space-y-2 text-xs">
          {result.rejected.map((r) => (
            <li key={r.accountCampaignId} className="border-t border-slate-100 pt-2">
              <div className="font-medium text-slate-800">{r.locationName}</div>
              <ul className="list-disc pl-4 text-slate-600">
                {r.reasons.map((msg, i) => (
                  <li key={i}>{msg}</li>
                ))}
              </ul>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
